"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Inbox/InboxList/NewChatListItemPlaceholder.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);

var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);
var _keyboard = require('web/services/keyboard');







const NewChatListItemPlaceholder = ({
  isSelected,
  onClick,
  onCancel,
}) => {
  const handleCancel = e => {
    e.stopPropagation()
    onCancel()
  }

  return (
    _react2.default.createElement('div', {
      role: "button", tabIndex: 0, onKeyDown: _keyboard.onButtonKeyDown,
      onClick: onClick,
      className: _classBuilder2.default.call(void 0, 
        "inbox-row",
        "inbox-list--new-chat-placeholder",
        isSelected && "inbox-list--new-chat-placeholder--selected",
      ), __self: this, __source: {fileName: _jsxFileName, lineNumber: 23}}

      , _react2.default.createElement('div', { className: "inbox-list--new-chat-placeholder--icon", __self: this, __source: {fileName: _jsxFileName, lineNumber: 32}}
        , _react2.default.createElement('img', { src: "/assets/icons/icon-edit-white.svg", alt: "Edit", __self: this, __source: {fileName: _jsxFileName, lineNumber: 33}} )
      )
      , _react2.default.createElement('span', { className: "inbox-list--new-chat-placeholder--label", __self: this, __source: {fileName: _jsxFileName, lineNumber: 35}}, "New message"

      )
      , _react2.default.createElement('div', {
        role: "button", tabIndex: 0, onKeyDown: _keyboard.onButtonKeyDown,
        onClick: handleCancel,
        className: "inbox-list--new-chat-placeholder--action", __self: this, __source: {fileName: _jsxFileName, lineNumber: 38}}

        , _react2.default.createElement('i', { className: "material-icons", __self: this, __source: {fileName: _jsxFileName, lineNumber: 43}}, "highlight_off")
        , _react2.default.createElement('span', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 44}}, "Cancel")
      )
    )
  )
}

exports. default = NewChatListItemPlaceholder
